// sm = 1x; md = 2x; lg = 3x
const sizes = {
  container: {
    sm: 'h-[3.125rem] w-[3.125rem]',
    md: 'h-[6.25rem] w-[6.25rem]',
    lg: 'h-[9.375rem] w-[9.375rem]',
  },
  diamond: {
    sm: 'h-[1.75rem] w-[1.75rem] border-4',
    md: 'h-[3.5rem] w-[3.5rem] border-8',
    lg: 'h-[5.25rem] w-[5.25rem] border-[12px]',
  },
  text: {
    sm: 'text-[2.5rem] mt-[2.5px]',
    md: 'text-[5rem] mt-[4px]',
    lg: 'text-[7.5rem] mt-[6.5px]',
  },
};

export type QbLogoSize = keyof typeof sizes.container;

type Props = {
  size?: QbLogoSize;
};

const QbLogo = ({ size = 'sm' }: Props) => {
  return (
    <div
      className={`relative flex ${sizes.container[size]} items-center justify-center`}
    >
      <div
        className={`absolute ${sizes.diamond[size]} rotate-45 rounded-md border-orange-400`}
      />
      <div className={`relative block h-full w-full`}>
        <span
          className={`inline-block ${sizes.text[size]} font-bold leading-none text-white`}
        >
          qb
        </span>
      </div>
    </div>
  );
};

export default QbLogo;
